"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uom_1 = require("uom");
var uom_units_1 = require("uom-units");
var AshraeHb2009 = require("../rp1485/ashrae-hb2009");
function massFlowToVolumeFlowUsingDensity(density, massFlow) {
    var flow = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerSecond, massFlow);
    var dens = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerCubicMeter, density);
    var volFlow = dens <= 0 ? 0 : flow / dens;
    return uom_1.Amount.create(volFlow, uom_units_1.Units.CubicMeterPerSecond);
}
exports.massFlowToVolumeFlowUsingDensity = massFlowToVolumeFlowUsingDensity;
function massFlowToVolumeFlow(temperature, humidity, pressure, massFlow) {
    var density = AshraeHb2009.calculateDensityOfMoistAirMixture(temperature, pressure, humidity);
    return massFlowToVolumeFlowUsingDensity(density, massFlow);
}
exports.massFlowToVolumeFlow = massFlowToVolumeFlow;
function volumeFlowToMassFlowUsingDensity(density, volumeFlow) {
    var volFlow = uom_1.Amount.valueAs(uom_units_1.Units.CubicMeterPerSecond, volumeFlow);
    var dens = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerCubicMeter, density);
    var flow = volFlow * dens;
    return uom_1.Amount.create(flow, uom_units_1.Units.KilogramPerSecond);
}
exports.volumeFlowToMassFlowUsingDensity = volumeFlowToMassFlowUsingDensity;
function volumeFlowToMassFlow(temperature, humidity, pressure, volumeFlow) {
    var density = AshraeHb2009.calculateDensityOfMoistAirMixture(temperature, pressure, humidity);
    return volumeFlowToMassFlowUsingDensity(density, volumeFlow);
}
exports.volumeFlowToMassFlow = volumeFlowToMassFlow;
